const Settings: React.FC = () => {
    return null;
}

export default Settings;